import { IModal } from "../../models/IModal";

//components
import { Button, Modal as ModalBootstrap, Row, Spinner } from "react-bootstrap";
import { IoIosWarning } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/theme";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { LoaderWrapper, ModalLoader } from "./styles";

export function Modal(props: IModal) {
	const { t: translation } = useTranslation();
	const { width } = useWindowDimensions();
	const {
		variant,
		headerTitle,
		onHide,
		onSubmit,
		children,
		showFooter = true,
		submitButtonText,
		cancelButtonText,
		disableOnSubmit = false,
		hasDefaultIcon = true,
		sizeApply = false,
		additionalFooterButton,
		loading,
		fullSizeLoader = false,
		hideControlsOnLoading = false,
		loadingText,
		buttonVariant,
	} = props;

	return (
		<ModalBootstrap
			{...props}
			{...(variant === "form-modal-default" &&
			width !== 1366 &&
			sizeApply === false
				? { size: "lg" }
				: {})}
			aria-labelledby="contained-modal-title-vcenter"
			centered
			backdrop="static"
			className={
				variant === "form-modal"
					? "modal-form-variant"
					: variant === "form-modal-default"
					? "modal-default-variant"
					: variant === "confirm-modal-default"
					? "modal-confirm-default-variant"
					: "modal-confirm-variant"
			}
		>
			<ModalBootstrap.Header closeButton>
				<ModalBootstrap.Title id="contained-modal-title-vcenter">
					{headerTitle}
				</ModalBootstrap.Title>
			</ModalBootstrap.Header>
			<ModalBootstrap.Body
				// para o modal não ficar maior do que a tela
				// 60px é a altura do header
				// 60px é o padding vertical da página, um "respiro"
				// 80px é a altura do footer, mas só uso quando showFooter
				style={{
					maxHeight: `calc(100svh - 60px - 60px${
						showFooter ? " - 80px" : ""
					}`,
					height: "100%",
					overflow: "auto",
				}}
			>
				{fullSizeLoader && loading ? (
					<LoaderWrapper
						className={` ${
							hideControlsOnLoading ? " expand-vertically" : ""
						}`}
					>
						<ModalLoader size={80} thickness={10}></ModalLoader>
						{loadingText && <p>{loadingText}</p>}
					</LoaderWrapper>
				) : variant === "form-modal" ||
				  variant === "form-modal-default" ? (
					children
				) : (
					<Row className="text-center text-darker-grey justify-content-center">
						{hasDefaultIcon && (
							<IoIosWarning
								className="mb-4"
								style={{
									fontSize: "4.5rem",
									color:
										variant === "confirm-modal"
											? colors.mainColors.crab_coral
											: colors.greyscale.grey,
								}}
							/>
						)}
						{children}
					</Row>
				)}
			</ModalBootstrap.Body>

			{showFooter ? (
				<ModalBootstrap.Footer
					style={{ position: "relative", zIndex: 2 }}
				>
					<Button
						variant="outline-primary"
						className="mb-1"
						onClick={() => onHide()}
					>
						{cancelButtonText
							? cancelButtonText
							: translation("cancel")}
					</Button>
					{additionalFooterButton && (
						<div style={{ marginLeft: "auto" }}>
							{additionalFooterButton}
						</div>
					)}
					{onSubmit && (
						<div>
							<Button
								type="button"
								variant={ buttonVariant ? buttonVariant : "primary"}
								className="mb-1"
								disabled={loading || disableOnSubmit}
								onClick={() => onSubmit()}
							>
								{submitButtonText}
							</Button>
							{loading && !fullSizeLoader && (
								<Spinner
									animation="border"
									variant={"primary"}
									style={{
										width: "1.2rem",
										height: "1.2rem",
										borderWidth: "0.15em",
										borderRightColor: "transparent",
										marginLeft: "5px",
									}}
								/>
							)}
						</div>
					)}
				</ModalBootstrap.Footer>
			) : (
				<></>
			)}
		</ModalBootstrap>
	);
}
